module.exports = __webpack_public_path__ + "img/Value.3d7b4180.png";